import Cookies from 'js-cookie';
import { useContext, useEffect, useState } from 'react';
import constants from '../../../constants/constants';
import { Button, DatePicker, Empty, Form, message, Space, Spin, Tabs } from 'antd';
import Chart from 'react-google-charts';
import APIUtils from '../../../api/APIUtils';
import WebLinks from '../../../api/WebLinks';
import dayjs from 'dayjs';
import * as XLSX from "xlsx";
import { FileExcelOutlined } from "@ant-design/icons";
import { CommonContext } from '../../../Context';

const CostPerAppHire = () => {
  const [loader, setLoader] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [activeKey, setActiveKey] = useState(constants.cpabyJobTitle);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const getDefaultDates = () => {
    const toDate = dayjs().format(constants.DateFormat2);
    const fromDate = dayjs().subtract(1, "month").format(constants.DateFormat2);
    return { fromDate, toDate };
  };
  const { fromDate: defaultFrom, toDate: defaultTo } = getDefaultDates();
  const [fromDate, setFromDate] = useState(defaultFrom);
  const [toDate, setToDate] = useState(defaultTo);
  const [apiCache, setApiCache] = useState({});
  const [parentTab, setParentTab] = useState("jobTitle");
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  useEffect(() => {
    if (TAB_CONFIG[activeKey]?.hasDateFilter) {
      if (fromDate && toDate) {
        getDashboardUrl();
      }
    } else {
      getDashboardUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, buyerId, fromDate, toDate]);
  useEffect(() => {
    const firstTab = TAB_GROUPS[parentTab][0];
    setActiveKey(firstTab);
  }, [parentTab]);

  const TAB_GROUPS = {
    jobTitle: [
      constants.cpabyJobTitle,
      constants.appVolumeByJobTitle,
      constants.cpiByJobTitle,
      constants.cphByJobTitle,
    ],
    occupation: [
      constants.cpabyOccupation,
      constants.appVolumeByOccupation,
      constants.costPerInterviewByOccupation,
      constants.costPerHireByOccupation,
    ],
  };
  const TAB_CONFIG = {
    [constants.cpabyJobTitle]: {
      label: constants.CPAByJobTitle,
      apiRoute: WebLinks.GetCostCPAbyJobTitle,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", ""),
      hasDateFilter: true,
    },
    [constants.appVolumeByJobTitle]: {
      label: constants.AppVolumeByJobTitle,
      apiRoute: WebLinks.GetCostCPAbyJobTitle,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", "#43946C"),
      hasDateFilter: true,
    },
    [constants.cpiByJobTitle]: {
      label: constants.CpiByJobTitle,
      apiRoute: WebLinks.GetCostCPAbyJobTitle,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", "#e89c31"),
      hasDateFilter: true,
    },
    [constants.cphByJobTitle]: {
      label: constants.CphByJobTitle,
      apiRoute: WebLinks.GetCostCPAbyJobTitle,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", "#4C1D5D"),
      hasDateFilter: true,
    },
    [constants.cpabyOccupation]: {
      label: constants.CPAByOccupation,
      apiRoute: WebLinks.GetCostCPAbyOccupation,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", ""),
      hasDateFilter: true,
    },
    [constants.appVolumeByOccupation]: {
      label: constants.AppVolumeByOccupation,
      apiRoute: WebLinks.GetCostCPAbyOccupation,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", "#43946C"),
      hasDateFilter: true,
    },
    [constants.costPerInterviewByOccupation]: {
      label: constants.CostPerInterviewByOccupation,
      apiRoute: WebLinks.GetCostCPAbyOccupation,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", "#e89c31"),
      hasDateFilter: true,
    },
    [constants.costPerHireByOccupation]: {
      label: constants.CostPerHireByOccupation,
      apiRoute: WebLinks.GetCostCPAbyOccupation,
      chartType: "ColumnChart",
      options: () => columnOptions("", "", "#4C1D5D"),
      hasDateFilter: true,
    },
  };
  const columnOptions = (titleX = "", titleY = "", color = "") => ({
    titlePosition: "none",
    chartArea: { top: 20, width: "80%", height: "80%" },
    legend: {
      position: "bottom",
      alignment: "center",
    },
    hAxis: {
      title: titleX,
      format: "0",
    },
    vAxis: {
      title: titleY,
      minValue: 0,
      format: "0",
    },
    colors: color ? [color] : undefined,
  });

  const formattedText = (apiData) => {
    let formattedData = [];
    let titleText = [];
    switch (activeKey) {
      case constants.cpabyJobTitle:
        titleText = ["Job Title", "CPA"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.jobtitle,
            item.cpa ? parseFloat(item.cpa.toFixed(2)) : 0,
          ]),
        ];
        break;
      case constants.appVolumeByJobTitle:
        titleText = ["Job Title", "Apps"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.jobtitle,
            item.apps ?? 0,
          ]),
        ];
        break;
      case constants.cpiByJobTitle:
        titleText = ["Job Title", "CPI"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.jobtitle,
            item.cpi ? parseFloat(item.cpi.toFixed(2)) : 0,
          ]),
        ];
        break;
      case constants.cphByJobTitle:
        titleText = ["Job Title", "CPH"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.jobtitle,
            item.cph ? parseFloat(item.cph.toFixed(2)) : 0,
          ]),
        ];
        break;
      case constants.cpabyOccupation:
        titleText = ["Occupation", "CPA"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.occupation,
            item.cpa ? parseFloat(item.cpa.toFixed(2)) : 0,
          ]),
        ];
        break;
      case constants.appVolumeByOccupation:
        titleText = ["Occupation", "Apps"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.occupation,
            item.apps ?? 0,
          ]),
        ];
        break;
      case constants.costPerInterviewByOccupation:
        titleText = ["Occupation", "CPI"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.occupation,
            item.cpi ? parseFloat(item.cpi.toFixed(2)) : 0,
          ]),
        ];
        break;
      case constants.costPerHireByOccupation:
        titleText = ["Occupation", "CPH"]
        formattedData = [
          titleText,
          ...apiData.map((item) => [
            item.occupation,
            item.cph ? parseFloat(item.cph.toFixed(2)) : 0,
          ]),
        ];
        break;
      default:
        formattedData = [];
    }
    return formattedData;
  }
  const getCacheKey = (key) => {
    let base = TAB_CONFIG[key]?.apiRoute;
    if (TAB_CONFIG[key]?.hasDateFilter) {
      return `${base}_${buyerId}_${fromDate}_${toDate}`;
    }
    return `${base}_${buyerId}`;
  };
  const buildDashboardUrl = (activeKey) => {
    let params = `buyerId=${buyerId}`;
    if (TAB_CONFIG[activeKey]?.hasDateFilter) {
      params += `&startDate=${fromDate}&endDate=${toDate}`;
    }
    return `${TAB_CONFIG[activeKey]?.apiRoute}?${params}`;
  };

  const getDashboardUrl = async () => {
    const cacheKey = getCacheKey(activeKey);
    if (apiCache[cacheKey]) {
      const cachedData = apiCache[cacheKey];
      setApiData(cachedData);
      setChartData(formattedText(cachedData));
      return;
    }
    setLoader(true);
    try {
      const url = buildDashboardUrl(activeKey);
      const response = await APIUtils.apiCall('GET', url);
      if (!response.isCatch && response.resultObj.statusCode === "2000") {
        const data = response.resultObj.data || [];
        setApiCache((prev) => ({
          ...prev,
          [cacheKey]: data,
        }));
        setApiData(data);
        setChartData(formattedText(data));
      } else {
        message.error(response?.resultObj?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Failed to fetch dashboard data");
    } finally {
      setLoader(false);
    }
  };

  const handleDateChange = (type, date, dateString) => {
    if (type === "from") {
      if (toDate && dayjs(dateString).isAfter(dayjs(toDate))) {
        message.error("From date cannot be after To date");
        return;
      }
      setFromDate(dateString);
    }

    if (type === "to") {
      if (fromDate && dayjs(dateString).isBefore(dayjs(fromDate))) {
        message.error("To date cannot be before From date");
        return;
      }
      setToDate(dateString);
    }
  };

  const disableDate = (type, current) => {
    if (!current || current > dayjs().endOf("day")) return true;

    const compareDate = type === "from" ? toDate : fromDate;
    if (!compareDate) return false;

    return type === "from"
      ? current > dayjs(compareDate)
      : current < dayjs(compareDate);
  };

  const handleChangeActiveKey = (e) => {
    setActiveKey(e);
  };

  const getChart = (type, options) => (
    loader ? (
      <Spin className='min-h-[50vh] flex justify-center items-center' />
    ) : !hasData ? (
      <Empty className='mt-5' description={constants.NO_DATA} />
    ) : (
      <Chart
        key={activeKey}
        chartType={type}
        height="600px"
        data={chartData}
        options={options}
      />
    )
  )
  const hasData = chartData ? chartData?.length > 1 : false;
  const downloadFile = (tabName) => {
    try {
      if (!apiData || apiData.length === 0) {
        message.error("No data to download");
        return;
      }
      setDownloadLoading(true);
      let excelData = [];
      switch (activeKey) {
        case constants.cpabyJobTitle:
          excelData = apiData.map(item => ({
            "Job Title": item.jobtitle,
            "CPA": item.cpa ? parseFloat(item.cpa.toFixed(2)) : 0,
          }));
          break;
        case constants.appVolumeByJobTitle:
          excelData = apiData.map(item => ({
            "Job Title": item.jobtitle,
            "Apps": item.apps ?? 0,
          }));
          break;
        case constants.cpiByJobTitle:
          excelData = apiData.map(item => ({
            "Job Title": item.jobtitle,
            "CPI": item.cpi ? parseFloat(item.cpi.toFixed(2)) : 0,
          }));
          break;
        case constants.cphByJobTitle:
          excelData = apiData.map(item => ({
            "Job Title": item.jobtitle,
            "CPH": item.cph ? parseFloat(item.cph.toFixed(2)) : 0,
          }));
          break;
        case constants.cpabyOccupation:
          excelData = apiData.map(item => ({
            "Occupation": item.occupation,
            "CPA": item.cpa ? parseFloat(item.cpa.toFixed(2)) : 0,
          }));
          break;
        case constants.appVolumeByOccupation:
          excelData = apiData.map(item => ({
            "Occupation": item.occupation,
            "Apps": item.apps ?? 0,
          }));
          break;
        case constants.costPerInterviewByOccupation:
          excelData = apiData.map(item => ({
            "Occupation": item.occupation,
            "CPI": item.cpi ? parseFloat(item.cpi.toFixed(2)) : 0,
          }));
          break;
        case constants.costPerHireByOccupation:
          excelData = apiData.map(item => ({
            "Occupation": item.occupation,
            "CPH": item.cph ? parseFloat(item.cph.toFixed(2)) : 0,
          }));
          break;
        default:
          message.warning("Download failed");
          setDownloadLoading(false);
          return;
      }
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      const fileName = TAB_CONFIG[activeKey]?.hasDateFilter
        ? `${tabName} ${fromDate} - ${toDate}.xlsx`
        : `${tabName}.xlsx`;
      setTimeout(() => {
        XLSX.writeFile(workbook, fileName);
        setDownloadLoading(false);
      }, 300);
    } catch (err) {
      setDownloadLoading(false);
      message.error("Error downloading file");
    }
  };
  const renderHeader = (tabName) => (
    <div className={`justify-end flex flex-wrap`}>
      <Button
        className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
        icon={<FileExcelOutlined />}
        onClick={() => downloadFile(tabName)}
        loading={downloadLoading}
      >
        Download as Excel
      </Button>
    </div>
  );
  const displayDate = () => {
    return (
      <Form>
        <Space>
          <Form.Item label="From" className="mb-3">
            <DatePicker
              onChange={(date, dateString) => handleDateChange("from", date, dateString)}
              value={fromDate ? dayjs(fromDate) : null}
              disabledDate={(current) => disableDate("from", current)}
              allowClear={false}
            />
          </Form.Item>
          <Form.Item label="To" className="mb-3">
            <DatePicker
              onChange={(date, dateString) => handleDateChange("to", date, dateString)}
              value={toDate ? dayjs(toDate) : null}
              disabledDate={(current) => disableDate("to", current)}
              allowClear={false}
            />
          </Form.Item>
        </Space>
      </Form>
    );
  };
  const getChildItems = (groupKey) =>
    TAB_GROUPS[groupKey].map((key) => {
      const config = TAB_CONFIG[key];
      return {
        key: String(key),
        label: config.label,
        children: (
          <>
            {renderHeader(config.label)}
            <div className="text-center text-xl">
              {config.label}{" "}
              {config?.hasDateFilter
                ? ` - ${fromDate} to ${toDate}`
                : ""}
            </div>
            {getChart(config.chartType, config.options())}
          </>
        ),
      };
    });
  return (
    <div>
      <Tabs
        activeKey={parentTab}
        onChange={setParentTab}
        items={[
          {
            key: "jobTitle",
            label: "Job Title",
            children: (
              <>
                {displayDate()}
                <Tabs
                  activeKey={activeKey}
                  onChange={handleChangeActiveKey}
                  items={getChildItems("jobTitle")}
                />
              </>
            ),
          },
          {
            key: "occupation",
            label: "Occupation",
            children: (
              <>
                {displayDate()}
                <Tabs
                  activeKey={activeKey}
                  onChange={handleChangeActiveKey}
                  items={getChildItems("occupation")}
                />
              </>
            ),
          },
        ]}
      />
    </div>
  );
};
export default CostPerAppHire;
